import React, {
    createContext,
    useContext,
    useEffect,
    useState,
    useCallback
} from 'react';
import PropTypes from 'prop-types';
import { getPromotionsBySweepId } from '../api/promotionsApi';

const PromotionsContext = createContext({ promotions: null });

export const PromotionsProvider = ({ sweepId, children }) => {
    const [promotions, setPromotions] = useState(null);

    const fetchPromotions = useCallback(async () => {
        if (!sweepId) {
            return;
        }
        const { data } = await getPromotionsBySweepId({ sweepId });
        setPromotions(data);
    }, [sweepId]);

    useEffect(() => {
        fetchPromotions();
    }, [fetchPromotions]);

    return (
        <PromotionsContext.Provider value={{ promotions }}>
            {children}
        </PromotionsContext.Provider>
    );
};

PromotionsProvider.propTypes = {
    sweepId: PropTypes.string,
    children: PropTypes.node.isRequired
};

PromotionsProvider.defaultProps = {
    sweepId: null
};

export const usePromotions = () => useContext(PromotionsContext);
